import React from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {
    return (
        <div className="carousel w-full my-6 ">
            <div id="slide1" className="carousel-item relative w-full ">

                <img className='rounded w-full' src="https://media.istockphoto.com/id/904265680/photo/serious-concentrated-male-international-student-preparing-for-upcoming-literature-test-reading.jpg?s=612x612&w=0&k=20&c=rPfyaRs-iosXr9FeRAh84heO1sZJgi4sCF3e3d1nERg= " />

                <div className="absolute flex justify-end transform -translate-y-1/2 left-24 top-1/4">
                    <h1 className='text-6xl font-bold text-white sm:text-1xl'>
                        Excellent <br /> Books Selling and Buying <br /> Platfrom
                    </h1>
                </div>

                <div className="absolute flex justify-start transform -translate-y-1/2 w-2/5 left-24 top-3/4">
                    <Link to='/services'><button className="btn btn-info mr-5 text-white">Discover More</button></Link>

                </div>
                <div className="absolute flex justify-end transform -translate-y-1/2 left-5 right-5 bottom-0">
                    <a href="#slide4" className="btn btn-circle mr-4">❮</a>
                    <a href="#slide2" className="btn btn-circle">❯</a>
                </div>
            </div>
            <div id="slide2" className="carousel-item relative w-full">
                <img src="https://media.istockphoto.com/id/1356940790/photo/portrait-of-a-bookseller-arranging-books-in-a-shelf.jpg?s=612x612&w=0&k=20&c=6S_BeIE1wC8vZBVAOeRGvlgO65gJj0PQiBTe6PvQ0kg=" className="w-full rounded" />

                <div className="absolute flex justify-end transform -translate-y-1/2 left-24 top-1/4">
                    <h1 className='text-6xl font-bold text-white sm:text-1xl'>
                        Excellent <br /> Books Selling and Buying <br /> Platfrom
                    </h1>
                </div>

                <div className="absolute flex justify-start transform -translate-y-1/2 w-2/5 left-24 top-3/4">
                    <button className="btn btn-info mr-5 text-white">Discover More</button>

                </div>
                <div className="absolute flex justify-end transform -translate-y-1/2 left-5 right-5 bottom-0">
                    <a href="#slide1" className="btn btn-circle mr-4">❮</a>
                    <a href="#slide3" className="btn btn-circle">❯</a>
                </div>
            </div>
            <div id="slide3" className="carousel-item relative w-full">
                <img src="https://media.istockphoto.com/id/1344079009/photo/librarian-helping-a-young-girl-to-search-for-a-book.jpg?s=612x612&w=0&k=20&c=Ef87c78kJONSDQusbEeFu9S4UpwXV3OxtjT7Y9acQro=" className="w-full rounded" />
                <div className="absolute flex justify-end transform -translate-y-1/2 left-24 top-1/4">
                    <h1 className='text-6xl font-bold text-white sm:text-1xl'>
                        Excellent <br /> Books Selling and Buying <br /> Platfrom
                    </h1>
                </div>

                <div className="absolute flex justify-start transform -translate-y-1/2 w-2/5 left-24 top-3/4">
                    <button className="btn btn-info mr-5 text-white">Discover More</button>

                </div>
                <div className="absolute flex justify-end transform -translate-y-1/2 left-5 right-5 bottom-0">
                    <a href="#slide2" className="btn btn-circle mr-4">❮</a>
                    <a href="#slide4" className="btn btn-circle">❯</a>
                </div>
            </div>

        </div>
    );
};

export default Banner;